import { useEffect, useState } from 'react';
import { useAdminSelector } from 'admin/reducers';
import { selectUserInfo } from 'admin/reducers/user/selectors';
import PubnubFacade from 'common/utils/facades/pubnub-facade';

export const usePubnubFacade = (): PubnubFacade | undefined => {
	const { id: userId } = useAdminSelector(selectUserInfo);
	const [pubnub, setPubnub] = useState<PubnubFacade>();

	useEffect(() => {
		if (!userId) {
			return;
		}

		setPubnub(prev => {
			if (prev) {
				prev.close();
			}
			return new PubnubFacade({ uuid: userId });
		});
	}, [userId]);

	return pubnub;
};
